import { styled } from 'styled-components';
import { breakpoints } from '../../../../abstracts/breakpoints';
import { ModalHeader as ModalHeaderBase, ModalTitle as ModalTitleBase, ModalSubTitle as ModalSubTitleBase, ModalMain as ModalMainBase, ModalScrollContainer as ModalScrollContainerBase } from '../DefaultModal/elements';
export const ModalScrollContainer = ModalScrollContainerBase;
export const ModalHeader = ModalHeaderBase;
export const ModalTitle = ModalTitleBase;
export const ModalMain = styled(ModalMainBase).withConfig({
  componentId: "aui__sc-sdfk5q-0"
})(["flex-direction:column-reverse;@media only screen and (", "){flex-direction:row;}"], breakpoints.lgMin);
export const ModalSubTitle = ModalSubTitleBase;
export const ModalIllustration = styled.div.withConfig({
  componentId: "aui__sc-sdfk5q-1"
})(["display:flex;justify-content:center;align-items:flex-start;margin:1rem;img{width:120px;}"]);